import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#F79406",
        primaryLighter: "#ffd18f",
        secondary: "#b0bec5",
        accent: "#50c79b",
        anchor: "#8c9eff",
        background: "#fffffff80",
      },
      dark: {
        // TODO
        primary: "#F79406",
        primaryLighter: "#ffd18f",
        secondary: "#b0bec5",
        accent: "#50c79b",
        anchor: "#8c9eff",
        background: "#6164c7",
      },
    },
  },
});

export default vuetify;
